import React, { useContext } from "react"
import Slider from "react-slick"
import { css } from "styled-components"
import { UIContext } from "../../components/shared/layout"
import {
  ContentfulResponsiveImage,
  IContentfulResponsiveImage,
} from "../atoms/breakpoint-image"
import VariantContainer from "../atoms/variant-container"
import { BackgroundColourContext } from "../util/background-colour-context"

export interface ICarouselProps {
  __typename: "ContentfulCarousel"
  images: IContentfulResponsiveImage[]
}

const Carousel = ({ images }: ICarouselProps) => {
  const {
    state: { clientLoaded },
  } = useContext(UIContext)
  const {
    state: { dark },
  } = useContext(BackgroundColourContext)
  return (
    clientLoaded && (
      <VariantContainer
        variants={[
          css`
            margin-bottom: 32px;
            ${dark
              ? css`
                  .slick-dots li button:before {
                    color: var(--white);
                  }
                `
              : null}
          `,
        ]}
      >
        <Slider dots arrows={false}>
          {images.map((image, index) => (
            <ContentfulResponsiveImage {...image} key={index} />
          ))}
        </Slider>
      </VariantContainer>
    )
  )
}

export const CAROUSEL_TYPENAME = "ContentfulCarousel"
export default Carousel
